import React from "react";
import "../../styles/components/facultyProfile/consultationHoursSection.scss";
import { Button, Table, Typography, Tag, Space } from "antd";
import { PlusCircleOutlined, UploadOutlined, UpOutlined, DownOutlined } from "@ant-design/icons";

// Not term-scoped — a faculty member's consultation hours are the same
// regardless of which academic term is selected elsewhere on the page.
export default function ConsultationHoursSection({
  columns,
  data,
  onAdd,
  onImport,
  onEdit,
  collapsed,
  onToggleCollapse,
}) {
  return (
    <div className="consultation-hours-section">
      <div className="header">
        <div className="header-row">
          <div
            style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}
            onClick={onToggleCollapse}
          >
            <Typography.Title
              level={3}
              style={{
                margin: 0,
                color: "#862633",
              }}
            >
              Consultation Hours
            </Typography.Title>
            <Tag color="green">Included in FSR</Tag>
          </div>

          <Space>
            {onImport && (
              <Button size="large" icon={<UploadOutlined />} onClick={onImport}>
                Import
              </Button>
            )}
            <Button
              size="large"
              style={{ background: "#00573F" }}
              icon={<PlusCircleOutlined />}
              type="primary"
              onClick={onAdd}
            >
              Add
            </Button>
            <Button
              shape="circle"
              icon={collapsed ? <DownOutlined /> : <UpOutlined />}
              style={{ border: "1px solid #862633", color: "#862633" }}
              onClick={onToggleCollapse}
            />
          </Space>
        </div>
      </div>

      {!collapsed && (
        <Table
          columns={columns}
          dataSource={data}
          scroll={{ x: "max-content" }}
          pagination={{ pageSize: 4 }}
          onRow={(record) => ({
            onClick: () => {
              if (onEdit) onEdit(record);
            },
            style: { cursor: "pointer" },
          })}
          rowKey={(record) => record.id}
        />
      )}
    </div>
  );
}
